import type { Maybe } from 'graphql/jsutils/Maybe';

import type { TargetingRuleDefinitionV4 } from '../../../../apis/graphql';
import { PRESET_ID, PRESET_SUB_CLASS } from '../../../TargetingDropdowns/constants';

export const mapTermList = (termList: Maybe<TargetingRuleDefinitionV4>[]): Maybe<TargetingRuleDefinitionV4>[] => {
  return termList.map((term) => {
    if (!term) return term;

    if (term.subClass === PRESET_SUB_CLASS && term.id && !term.dimension) {
      return { ...term, dimension: PRESET_ID, valueSet: [term.id] };
    }

    if (!term.rangeList?.length) {
      return term;
    }

    return {
      ...term,
      valueSet:
        term.rangeList.map((rangeObj) => `${rangeObj?.lower ?? 'NOT_FOUND'} - ${rangeObj?.upper ?? 'NOT_FOUND'}`) || [],
    };
  });
};
